/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withLocalization } from 'hocs/localization'
import { ROUTES } from 'constants/routes'
import { ALERTS } from 'constants/alerts'
import { createAlert, onShowError } from 'redux-app/modules/alerts'
import { addMeToWaitlist } from 'api/client/actions/auth'
import { isUserAuthorizated } from 'redux-app/selectors/auth'
import { getSelectedPlanId } from 'redux-app/selectors/subscription'
import NoAvailablePrinter from './NoAvailablePrinter'

export default compose(
  connect(
    state => ({
      isUserAuthorizated: isUserAuthorizated(state),
      selectedPlanId: getSelectedPlanId(state),
    }),
    {
      createAlert,
      onAddToWaitlist: addMeToWaitlist,
      onShowError,
    },
  ),
  withRouter,
  withHandlers({
    onAddToWaitlist: ({
      isUserAuthorizated,
      history,
      createAlert,
      onAddToWaitlist,
      onShowError,
      selectedPlanId,
    }) => event => {
      event.preventDefault()
      if (isUserAuthorizated) {
        onAddToWaitlist(selectedPlanId)
          .then(() => {
            createAlert({ name: ALERTS.successLeaveEmail })
            history.replace(ROUTES.profile.view)
          })
          .catch(error => {
            onShowError(error)
          })
      } else {
        history.replace(ROUTES.home.leaveEmail)
      }
    },
    onGoToEnrollSubscription: ({ history }) => event => {
      event.preventDefault()
      history.push(ROUTES.profile.enrollPlan.root)
    },
  }),
  withLocalization('noAvailablePrinter'),
)(NoAvailablePrinter)
